import React from 'react'

function PropertiyGallerySkeleton() {
  return (
    <div className="h-full w-full">
      <div className="shimmer-container h-full w-full" />
    </div>
  )
}

export default PropertiyGallerySkeleton
